<mat-toolbar class="d-flex justify-content-start align-items-center flex-row tw-z-20"
  [ngClass]="authService.user !== null && !authService.user['confirmed'] ? 'top-92 md:top-108 lg:top-92' : 'tw-top-16 md:tw-top-20 lg:tw-top-16'">
  <ngx-workspaces-search *ngIf="authService.user !== null" class="form-padded flex-grow-1" (noMoreWorkspaces)="showNoMore($event)"
    (workspacesChanged)="propagateWorkspaces($event)"
    [ngClass]="{ 'ml-2': role() !== 'Sub Entity' }"></ngx-workspaces-search>
</mat-toolbar>
<ng-template #dialog let-data let-ref="dialogRef">
  <ngx-workspaces-invoice-plans [createWorkspace]="true" (close)="ref.close()"></ngx-workspaces-invoice-plans>
</ng-template>